import React, { Fragment, useEffect, useRef, useState } from 'react';
import { DropDownBody, Small, CenteredBold, PageTitle, PageBody, PageSummary, PreviewSection, GenericButtonBody } from "../styledComponents";
import { Input, Dropdown } from "../components";

import config from "../config";

function Contact(props) {

  // const [template, setTemplate] = useState("DEFUNDLAPD");
  const [name, setName] = useState("[FULL NAME]");
  const [region, setRegion] = useState("[CITY, STATE]");
  const [petition, setPetition] = useState(false);
  const [template, setTemplate] = useState(config.templateKeys[0].key);
  const [email, setEmail] = useState(config.emailGenerator(config.templateKeys[0].key, name, region));

  const updateName = (input) => {
    setName(input.target.value);
    setEmail(config.emailGenerator(template, input.target.value, region));
  }

  const updateRegion = (input) => {
    setRegion(input.target.value);
    setEmail(config.emailGenerator(template, name, input.target.value));
  }

  const useTemplate = (input, petitionLink) => {
    setTemplate(input.target.value);
    setEmail(config.emailGenerator(input.target.value, name, region));
  }

  const renderEmailSection = () => {
    return (
      <>
        <DropDownBody>
        <label>Choose a demand</label>
        <Dropdown keys={config.templateKeys} onChange={useTemplate}/>
      </DropDownBody>
      {!petition && <Input label={"FULL NAME"} onChange={updateName} name="name"/>}
      {!petition && <Input label={"CITY, STATE"} onChange={updateRegion} name="city" />}
      <Small>
        <GenericButtonBody href={email.encoded}>
          Create Email
      </GenericButtonBody>
      </Small>
      <PreviewSection>
        <CenteredBold>Email Preview</CenteredBold>
        {email.web}
      </PreviewSection>
      <GenericButtonBody href={email.encoded}>
        Create Email
      </GenericButtonBody>
      </>
    )
  }

  return (
    <PageBody>
      <PageTitle>Demand Change</PageTitle>
      <PageSummary>Contact those in politics to make the changes we need to see</PageSummary>
      {renderEmailSection()}
    </PageBody>
  );
}

export default Contact;
